<template>
  <div>
    
    
    <div>
        已匯入資料，視窗將自動關閉，或請
        <b-button @click="close">點我關閉</b-button>
    </div>
    
  </div>
</template>

<script>
import { Member } from "../api/api.js";
import moment from "moment";
export default {
  data() {
    return {
        token : this.$route.query.token,
        memb : {}
    };
  },
  mounted(){
    Member(this.token).then(c => {
      this.memb = c.data;
      this.memb.Birth = moment(this.memb.Birth).format("YYYY-MM-DD") ;
      localStorage.setItem("mem" + this.no , JSON.stringify(this.memb));
      
      let delay = 500;
      setTimeout(() => {
        window.close();
    }, delay)
    })
    
  },
  methods:{
    close(){
      window.close();
    },

  },
  props: {
    no: String,
  },
};

</script>

<style>
</style>